import gql from 'graphql-tag';

export const DeleteForm = gql`
  mutation DeleteForm($organizationId: ID!, $formId: ID!) {
    deleteForm(organizationId: $organizationId, formId: $formId) {
      id
    }
  }
`;
